<template>
 <table>
   <tbody>
   <tr>
     <th colspan="3">Стоимость замены котла</th>
   </tr>
   <tr>
     <th>Модель</th>
     <th>Мощность, кВт.</th>
     <th>Цена, руб.</th>
   </tr>
   <tr>
     <td>навесной витопенд</td>
     <td>24-35</td>
     <td>от 12 000</td>
   </tr>
   <tr>
     <td rowspan="2">навесной витоденс</td>
     <td>24-100</td>
     <td>от 15 000</td>
   </tr>
   <tr>
     <td>100-150</td>
     <td>от 25 000</td>
   </tr>
   <tr>
     <td rowspan="3">напольный витогаз</td>
     <td>29-60</td>
     <td>от 20 000</td>
   </tr>
   <tr>
     <td>72-96</td>
     <td>от 30 000</td>
   </tr>
   <tr>
     <td>108-140</td>
     <td>от 40 000</td>
   </tr>
    <tr>
      <td>напольный витокроссал</td>
      <td>-</td>
      <td>от 50 000</td>
    </tr>
   <tr>
     <td rowspan="2">напольный виторонд</td>
     <td>35-100</td>
     <td>от 20 000</td>
   </tr>
   <tr>
     <td>100-200</td>
     <td>от 40 000</td>
   </tr>
   <tr>
     <td>напольный витоплекс</td>
     <td>до 275</td>
     <td>от 50 000</td>
   </tr>
   </tbody>
 </table>
</template>

<script>
  export default {

  }
</script>

<style scoped>

</style>